export const DiamondMark = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="dm" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#B57BFF" />
        <stop offset="1" stopColor="#E8C46A" />
      </linearGradient>
    </defs>
    <path d="M12 2 L21 12 L12 22 L3 12 Z" fill="url(#dm)" />
  </svg>
);

export const Wordmark = ({ className = "" }) => (
  <span className={`font-display font-black tracking-[0.12em] text-gold-purple ${className}`}>SEEDOSELLZ</span>
);
